import type { IconNode } from '../types';

/**
 * @name towel-rack
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCA2SDIiIC8+CiAgPHBhdGggZD0iTTYgMmgxMmEyIDIgMCAwIDEgMiAydjE4SDhWNGEyIDIgMCAwIDAtNCAwdjE1aDQiIC8+CiAgPHBhdGggZD0iTTIyIDZoLTIiIC8+CiAgPHBhdGggZD0iTTggMThoMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/towel-rack
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const towelRack: IconNode = [
  ['path', { d: 'M8 6H2', key: '1gr76m' }],
  ['path', { d: 'M6 2h12a2 2 0 0 1 2 2v18H8V4a2 2 0 0 0-4 0v15h4', key: '1yioeh' }],
  ['path', { d: 'M22 6h-2', key: '1cdk8s' }],
  ['path', { d: 'M8 18h12', key: '1f03ww' }],
];

export default towelRack;
